import { reactEvents } from '../../../../../bridge/reactEvents';

// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('variant.general', {
    url: '/general',
    templateUrl: 'main/article/variant/general/general.tpl.html',
    controller: 'VariantGeneralController as vm',
  });
};

class VariantGeneralController {
  constructor(
    $scope,
    variant,
    loadSpinnerService,
    ArticlesApiService,
    HelperService,
    AuthService,
    toasterService,
    SavingService,
  ) {
    'ngInject';

    this.$scope = $scope;
    this.originalVariant = variant;
    this.loadSpinnerService = loadSpinnerService;
    this.ArticlesApiService = ArticlesApiService;
    this.HelperService = HelperService;
    this.AuthService = AuthService;
    this.toasterService = toasterService;
    this.SavingService = SavingService;

    this.validationErrors = [];

    this.variantNameChangedEvent = reactEvents.variantNameChanged.subscribe(
      (variant) => {
        this.setVariantName(variant);
      },
    );

    this.setVariantClone();
  }

  setVariantClone() {
    this.variant = _.extend({}, this.originalVariant);
  }

  save(data, successMessage) {
    this.validationErrors = [];
    this.loadSpinnerService.start('mainSpinner');
    this.ArticlesApiService.updateVariant(data, this.variant.id)
      .then(
        () => {
          this.setVariantClone();
          this.toasterService.success(successMessage);
        },
        (error) => (this.validationErrors = error.errors),
      )
      .finally(() => this.loadSpinnerService.stop('mainSpinner'));
  }

  archive() {
    const successMessage = `${this.variant.name} ${
      this.variant.archived ? 'restored' : 'archived'
    }`;
    this.save({ archived: !this.variant.archived }, successMessage);
  }

  setAsMain() {
    this.loadSpinnerService.start('mainSpinner');
    this.ArticlesApiService.setMainVariant(
      this.variant.articleId,
      this.variant.id,
    )
      .then(
        () => {
          this.originalVariant.article.mainVariantId = this.variant.id;
          this.toasterService.success();
        },
        (error) => (this.validationErrors = error.errors),
      )
      .finally(() => this.loadSpinnerService.stop('mainSpinner'));
  }

  setVariantName(variant) {
    this.originalVariant.variantName = variant.value;
    this.variant.name = variant.value;
  }
}

angular
  .module('main.article.variant.general', ['main.article.variant.general.garp'])
  .config(config)
  .controller('VariantGeneralController', VariantGeneralController);
